export { getFontSize, getFontSizeClass } from './utils';
